import * as Reducers from '../reducers';
import reducerFiles from './reducerFiles';

const reducerNames = reducerFiles
  .map((name) => name.replace(/.\//, '').replace(/.js/, ''))
  .filter((name) => name !== 'index');

export const initialState = reducerNames.reduce((previousState, reducerName) => ({
  ...previousState,
  ...Reducers[reducerName].INITIAL_STATE,
}), {
  info: {}, // { info }
  books: {}, // {s => {bids | asks => [...]}}
  orders: [],
});

export const reducer = (state = initialState, action) => {
  state = reducerNames.reduce(
    (previous, reducerName) => Reducers[reducerName].reducer(previous, action), state
  );
  return state;
};

export default reducer;
